import PropTypes from "prop-types";
import { CircularProgress, Fade } from "@mui/material";

// eslint-disable-next-line no-unused-vars
export default function ProgressCirc({ color = "primary", ...props }) {
  const size = props.size || 14;
  const gutterTop = props.gutterTop || false;
  const height = props.height || "100%";
  const isLoading = props.isLoading === false ? false : true;
  const gutterPx = props.gutterPx || (gutterTop ? "10px" : "0px");
  const unmountOnExit = props.unmountOnExit === false ? false : true;
  const variant = props.variant || "indeterminate";
  const open = props.open === undefined ? true : props.open;

  const styles = {
    div1: {
      paddingTop: gutterPx,
      paddingBottom: gutterPx,
      height: height,
    },
  };

  if (!open) return null;

  return (
    <Fade in={isLoading} timeout={400} unmountOnExit={unmountOnExit}>
      <div style={styles.div1} className="center">
        <div style={props.style} className="center">
          <CircularProgress size={size} variant={variant} value={props.value} />
        </div>
      </div>
    </Fade>
  );
}

ProgressCirc.propTypes = {
  socket: PropTypes.object,
  size: PropTypes.number,
  gutterTop: PropTypes.bool,
  gutterPx: PropTypes.string,
  height: PropTypes.string,
  isLoading: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
  variant: PropTypes.string,
  value: PropTypes.number,
  open: PropTypes.bool,
  style: PropTypes.object,
  color: PropTypes.string,
};
